import type { CustomerTemplateContextType } from '@/types/shipping-types';
import { createContext, useContext } from 'react';

export const TemplateContext = createContext<
  CustomerTemplateContextType | undefined
>(undefined);

export const useTemplateContext = () => {
  const context = useContext(TemplateContext);
  if (!context) {
    throw new Error(
      'useTemplateContext must be used within a TemplateContextProvider',
    );
  }
  return context;
};
